<template>
	<ItemPickerDialog :model-value="pickerState.visible" :title="pickerState.title" :icon="pickerState.kind === 'offer' ? 'local_offer' : 'add_shopping_cart'" :items="pickerState.items" :thumbnails="pickerState.kind !== 'offer'" :empty-text="t(pickerState.kind === 'offer' ? 'PromoNoOfferToAdd' : 'PromoNoProductToAdd')" @update:model-value="(open) => !open && closePicker([])" @select="closePicker" />
</template>

<script setup>
import ItemPickerDialog from '@/components/dialogs/ItemPickerDialog.vue';
import { usePromoStep } from '@/composables/usePromoStep';

const { pickerState, closePicker, t } = usePromoStep();
</script>
